import React from "react";

const BusinessMeaning = () => {
  return (
    <div className="relative flex w-full mt-32">
      <div className="w-full flex flex-col items-center text-center gap-10">
        <h1 className="font-impact text-7xl w-2/3">
          What Does This Mean for Businesses?
        </h1>
        <p className="text-lg font-manrope w-3/4">
          As a business entity, you can enable your users to effortlessly send
          crypto across different blockchain networks supported by Cahex or even
          make crypto transfers to a digital bank account. TRON is one of the
          blockchain networks integrated by Cahex Network. By helping TRON
          access more liquidity via Cahex Network, we enable TRON dApps and
          users to make cross-chain money transfers across the TRON ecosystem.
          In this article, we will guide you through a step-by-step process of
          transferring money and accepting payments using the power of Cahex
          Network. But first things first…
        </p>
        <div className="flex items-center justify-center">
        <img src="/Images/shap2.png" alt="" />
        <img src="/Images/isometric c letter.png" alt="" className="absolute" />
        </div>
        <img
          src="/Images/shap3.png"
          alt=""
          className="absolute bottom-32 right-0 w-32"
        />
        <img
          src="/Images/shap3.png"
          alt=""
          className="absolute top-20 left-0 w-32"
        />
      </div>
    </div>
  );
};

export default BusinessMeaning;
